var map = {
	"./GERMAN_IDENTITY_CARD_0.webp": 34746,
	"./GERMAN_IDENTITY_CARD_1.webp": 6245,
	"./GERMAN_IDENTITY_CARD_2.webp": 45144,
	"./GERMAN_IDENTITY_CARD_3.webp": 37947,
	"./GERMAN_IDENTITY_CARD_4.webp": 96438,
	"./GERMAN_IDENTITY_CARD_NEW_0.webp": 80979,
	"./GERMAN_IDENTITY_CARD_NEW_1.webp": 58768,
	"./GERMAN_IDENTITY_CARD_NEW_2.webp": 36669,
	"./GERMAN_IDENTITY_CARD_NEW_3.webp": 33906,
	"./GERMAN_IDENTITY_CARD_NEW_4.webp": 72687,
	"./GERMAN_IDENTITY_CARD_NEW_extra.webp": 7881,
	"./GERMAN_IDENTITY_CARD_extra.webp": 1672,
	"./GERMAN_PASSPORT_0.webp": 51241,
	"./GERMAN_PASSPORT_1.webp": 55214,
	"./GERMAN_PASSPORT_2.webp": 31855,
	"./GERMAN_PASSPORT_3.webp": 56972,
	"./GERMAN_PASSPORT_4.webp": 33917,
	"./GERMAN_PASSPORT_extra.webp": 48867
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6398;